var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.37 197.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m99.55,164.25c-16.79,0-35.59-10.55-40.58-34.48-.32-1.52.07-3.1,1.05-4.31.98-1.21,2.45-1.91,4-1.91h69.33c1.51,0,2.94.66,3.92,1.8.98,1.14,1.41,2.66,1.19,4.14-3.58,23.39-21.58,34.3-37.83,34.74-.35,0-.71.01-1.07.01Zm-28.65-30.37c5.52,14.19,18.2,20.35,29.44,20.04,9.82-.26,21.9-5.78,26.52-20.04h-55.95Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 62.4,
    cy: 78.34,
    r: 11.53,
    transform: "translate(-33.86 106.01) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.97,
    cy: 78.34,
    r: 11.53,
    transform: "translate(10.94 173.06) rotate(-67.5)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m98.69,197.37C44.27,197.37,0,153.1,0,98.69S44.27,0,98.69,0s98.69,44.27,98.69,98.69-44.27,98.69-98.69,98.69Zm0-187.05C49.96,10.32,10.32,49.96,10.32,98.69s39.64,88.36,88.36,88.36,88.36-39.64,88.36-88.36S147.41,10.32,98.69,10.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Black);
export default __webpack_public_path__ + "static/media/1Black.b38fd0730acb5712b671af52dca8693a.svg";
export { ForwardRef as ReactComponent };